<template>
  <NamiSelectMultiple
    :modelValue="modelValue"
    @update:modelValue="(v) => emit('update:modelValue', v)"
    :options="data ?? Array(4).fill({ text: 'Loading', value: 'loading' })"
    :label="label"
    :disabled="disabled"
    :placeholder="placeholder"
  >
    <template #option="{ active, option, selected }">
      <Skeleton v-if="pending" class="h-9 my-1 mx-2" />
      <div v-else-if="error" class="text-red-500">
        {{ error }}
      </div>
      <div
        v-else
        :class="[
          active ? 'bg-neutral-200 dark:bg-neutral-800' : '',
          'relative cursor-pointer text-neutral-900 dark:text-neutral-100 select-none py-2 pr-3 pl-9',
        ]"
      >
        <span
          :class="[
            selected ? 'font-semibold' : 'font-normal',
            'block truncate',
          ]"
          >{{ option.text }}</span
        >

        <span
          v-if="selected"
          class="absolute inset-y-0 left-0 flex items-center pl-2 text-neutral-800 dark:text-neutral-200"
        >
          <IconCircleCheck class="h-5 w-5" aria-hidden="true" />
        </span>
        <span
          v-else
          class="absolute inset-y-0 left-0 flex items-center pl-2 text-neutral-800 dark:text-neutral-200"
        >
          <svg view-box="0 0 24 24" class="h-5 w-5" aria-hidden="true">
            <circle
              cx="50%"
              cy="50%"
              r="7.5"
              stroke-width="1"
              fill="none"
              stroke="currentColor"
            />
          </svg>
        </span>
      </div>
    </template>
  </NamiSelectMultiple>
</template>

<script setup lang="ts">
import { IconCircleCheck } from "@tabler/icons-vue";

type Option = {
  text: string;
  value: string;
};

const props = defineProps<{
  modelValue: string[];
  fetcher: () => Promise<Option[]>;
  label?: string;
  disabled?: boolean;
  placeholder?: string;
}>();

const emit = defineEmits<{
  (e: "update:modelValue", v: string[]): void;
}>();

const { pending, data, error } = useAsyncData(
  "selection",
  async () => {
    return await props.fetcher();
  },
  { server: false },
);
</script>
